module.exports = __webpack_public_path__ + "img/摄图网_500431060_banner.2badedc4.png";